import clsx from "clsx";
import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { accomplishments } from "../constants"; // adjust the path

export default function AccomplishmentList() {
  const [isMobile, setIsMobile] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const limit = 7;

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768); // Tailwind's `md` breakpoint
    };
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const visibleAccomplishments =
    isMobile && !expanded ? accomplishments.slice(0, limit) : accomplishments;

  return (
    <div className={accomplishmentsWrapper}>
      <AnimatePresence initial={false}>
        {visibleAccomplishments.map((item, index) => (
          <motion.div
            key={index}
            className={accomplishmentItem}
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -6 }}
            transition={{ duration: 0.2 }}
          >
            {item}
          </motion.div>
        ))}
      </AnimatePresence>

      {isMobile && accomplishments.length > limit && (
        <motion.button
          onClick={() => setExpanded(!expanded)}
          className="w-full text-left text-[11px] mt-2 text-black underline underline-offset-2"
          whileTap={{ scale: 0.97 }}
        >
          {expanded ? "Show Less" : "Show More"}
        </motion.button>
      )}
    </div>
  );
}

const accomplishmentsWrapper = clsx(
  "flex items-start flex-wrap text-[10px] overflow-scoll mt-10 lg:mb-20 mb-10"
);
const accomplishmentItem = clsx(
  "lg:w-[300px] w-full lg:mr-8 lg:mb-8 mb-4 border-l-4 border-black pl-2 py-2 flex bg-black/[3%]"
);
